import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api from "../lib/api";
import NewsCard from "../components/NewsCard";

export function CategoriesIndex() {
  const [cats, setCats] = useState([]);
  useEffect(() => {
    (async () => {
      const { data } = await api.get("/categories");
      setCats(data);
    })();
  }, []);
  return (
    <div className="pt-28 pb-20 max-w-[1400px] mx-auto px-6 md:px-10">
      <h1 className="font-display font-bold text-5xl md:text-6xl text-white tracking-tighter mb-10">
        All Categories
      </h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="category-grid">
        {cats.map((c) => (
          <Link
            key={c.id}
            to={`/categories/${c.slug}`}
            data-testid={`category-tile-${c.slug}`}
            className="block bg-[#0a0a0b] border border-white/10 p-8 hover:border-yellow-400/40 hover:-translate-y-1 transition group"
          >
            <span className="font-mono text-xs text-yellow-400 uppercase tracking-[0.2em]">/{c.slug}</span>
            <h3 className="font-display font-bold text-3xl text-white mt-4 group-hover:text-yellow-400 transition">
              {c.name}
            </h3>
            <p className="mt-3 text-sm text-zinc-400">{c.description}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}

export function CategoryDetail() {
  const { slug } = useParams();
  const [items, setItems] = useState([]);
  const [cat, setCat] = useState(null);
  useEffect(() => {
    (async () => {
      const [a, b] = await Promise.all([
        api.get(`/news?category=${slug}&limit=50`),
        api.get(`/categories`),
      ]);
      setItems(a.data);
      setCat(b.data.find((c) => c.slug === slug));
    })();
  }, [slug]);
  return (
    <div className="pt-28 pb-20 max-w-[1400px] mx-auto px-6 md:px-10">
      <span className="font-mono text-xs text-yellow-400 uppercase tracking-[0.2em]">/{slug}</span>
      <h1 className="font-display font-bold text-5xl md:text-6xl text-white tracking-tighter mt-2 mb-2">
        {cat?.name || slug}
      </h1>
      <p className="text-zinc-400 mb-10">{cat?.description}</p>
      {items.length === 0 ? (
        <div className="text-zinc-500">No articles in this category yet.</div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((a) => <NewsCard key={a.id} article={a} />)}
        </div>
      )}
    </div>
  );
}
